var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger fade show text-center",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-triangle me-2"}),_vm._v(" "),_c('strong',[_vm._v("Ops!")]),_vm._v("\n  Errore durante il caricamento dei dati, vi preghiamo di provare più tardi.\n")])
}]

export { render, staticRenderFns }